import Vue from 'vue'
import Router from 'vue-router'
import shop from '@/components/shop'
import noble from '@/components/noble'
import earnings from '@/components/earnings'
import invitation from '@/components/invitation'
import invitationSubordinate from '@/components/invitation_subordinate'
import invitationEarnings from '@/components/invitation_earnings'
import invitationRecord from '@/components/invitation_record'
import invitationWithdrawal from '@/components/invitation_withdrawal'
import invitationPinless from '@/components/invitation_pinless'
import invitationSuperior from '@/components/invitation_superior'
import invitationShare from '@/components/invitation_share'
import contact from '@/components/contact'
import emcee_center from '@/components/emcee_center'
import emcee_income_log from '@/components/emcee_income_log'
import emcee_center_select_live_time from '@/components/emcee_center_select_live_time'
import my_shop from '@/components/my_shop'
import create_shop from '@/components/create_shop'
import shop_manage from '@/components/shop_manage'
import shop_add from '@/components/shop_add'
import shop_product_list from '@/components/shop_product_list'
import vip from '@/components/vip'
import vip_grade from '@/components/vip_grade'
import vip_task from '@/components/vip_task'
import agent from '@/components/agent'
import UpSharemoney from '@/components/UpSharemoney'
import shareDownload from '@/components/shareDownload'
import invitationRules from '@/components/invitationRules'
import reflect from '@/components/reflect'
import firstlevelteam from '@/components/firstlevelteam'
import RealnameAuthentication from '@/components/RealnameAuthentication'
import download from '@/components/download'
import shareLive from '@/components/shareLive'
import turntable from '@/components/turntable'
import greedy from '@/components/greedy'
import banding_bank from '@/components/banding_bank'
import agent_login from '@/components/agent_login'
import agent_admin from '@/components/agent_admin'
import video_rich_ranking from '@/components/video_rich_ranking'
import game_list from '@/components/game_list'
import game_picture_list from '@/components/game_picture_list'
import month_statistics from '@/components/month_statistics'
import month_statistics_log from '@/components/month_statistics_log'
import avatar_frame from '@/components/avatar_frame'
import revenue_records from '@/components/revenue_records'
import play_svga from '@/components/play_svga'
import room_flow from '@/components/room_flow'
import item_shop from '@/components/item_shop'
import item_shop_car from '@/components/item_shop_car'
import item_shop_vip from '@/components/item_shop_vip'
import item_shop_lucky from '@/components/item_shop_lucky'
import item_shop_avatar from '@/components/item_shop_avatar'
import item_shop_my from '@/components/item_shop_my'
import banding_top_bank from '@/components/banding_top_bank'
import ranking_user from '@/components/ranking_user'
import agency_recharge from '@/components/agency_recharge'
import ranking_family from '@/components/ranking_family'
import ranking_homepage from '@/components/ranking_homepage'
import creator_agency_apply from '@/components/creator_agency_apply'
import creator_agency_apply_details from '@/components/creator_agency_apply_details'
import creator_agency from '@/components/creator_agency'
import my_agency from '@/components/my_agency'
import join_agency from '@/components/join_agency'
import coin_seller from '@/components/coin_seller'
import wallet from '@/components/wallet'
import withdraw_payroll from '@/components/withdraw_payroll'
import approve_order from '@/components/approve_order'
import creator_user from '@/components/creator_user'
import creator_agency_history from '@/components/creator_agency_history'
import creator_daily_income from '@/components/creator_daily_income'
import coin_seller_payment_method_select from '@/components/coin_seller_payment_method_select'
import coin_seller_payment_method from '@/components/coin_seller_payment_method'
import coin_seller_details from '@/components/coin_seller_details'
import coin_seller_details_v2 from '@/components/coin_seller_details1'
import edit_quick_messages from '@/components/edit_quick_messages'
import coin_seller_ranking from '@/components/coin_seller_ranking'
import payroll_seller_payment_method from '@/components/payroll_seller_payment_method'
import payroll_seller_payment_method_select from '@/components/payroll_seller_payment_method_select'
import withdraw_payroll_order from '@/components/withdraw_payroll_order'
import help_feedback from '@/components/help_feedback'
import withdraw_payroll_search_order from '@/components/withdraw_payroll_search_order'
import wallet_details from '@/components/wallet_details'
import withdraw_record from '@/components/withdraw_record'
import sign_in from '@/components/sign_in'
import ranking_all from '@/components/ranking_all'
import ranking_all_reward from '@/components/ranking_all_reward'
import coin_seller_recharge from '@/components/coin_seller_recharge'
import creator_success from '@/components/creator_success'
import creator_user_commission from '@/components/creator_user_commission'
import withdraw_message from '@/components/withdraw_message'
import withdraw_message_new from '@/components/withdraw_message_new'
import my_level from '@/components/my_level'
import rank_coin from '@/components/rank_coin'
import rank_list from '@/components/rank_list'
import online_service from '@/components/online_service'
import feedback_log from '@/components/feedback_log'
import feedback from '@/components/feedback'
import follow_us from '@/components/follow_us'
import help from '@/components/help'
import feedback_message from '@/components/feedback_message'
import about_us from '@/components/about_us'

import vip_noble from '@/components/vip_noble'

import creator_country from '@/components/creator_country'
import creator_country_invite from '@/components/creator_country_invite'
import creator_country_reward_record from '@/components/creator_country_reward_record'
import creator_country_agency from '@/components/creator_country_agency'
import creator_country_user from '@/components/creator_country_user'
import creator_country_invite_success from '@/components/creator_country_invite_success'
import creator_country_agency_income from '@/components/creator_country_agency_income'
import creator_country_user_income from '@/components/creator_country_user_income'

import coin_dealer from '@/components/coin_dealer'
import coin_dealer_v2 from '@/components/coin_dealer_v2'
import coin_dealer_recharge_exchange from '@/components/coin_dealer_recharge_exchange'
import coin_dealer_recharge_exchange_v2 from '@/components/coin_dealer_recharge_exchange_v2'

import coin_dealer_rule from '@/components/coin_dealer_rule'
import host_activity from '@/components/host_activity'
import host_activity_rule from '@/components/host_activity_rule'
import host_activity_log from '@/components/host_activity_log'

import bdm_system from '@/components/bdm_system'
import bdm_center from '@/components/bdm_center'
import agc_center from '@/components/bdm_agc_center'
import bdm_management from '@/components/bdm_management'
import bdm_seller_management from '@/components/bdm_seller_management'
import bdm_payroll_management from '@/components/bdm_payroll_management'
import bdm_distribute_reward from '@/components/bdm_distribute_reward'
import bdm_distribute_reward_log from '@/components/bdm_distribute_reward_log'
import bdm_host_management from '@/components/bdm_host_management'
import bdm_reward_log from '@/components/bdm_reward_log'
import bdm_article from '@/components/bdm_article'
import bdm_host_rank from '@/components/bdm_host_rank'
import bdm_message from '@/components/bdm_message'
import agc_system from '@/components/bdm_agc_system'
import weekly_recharge_benefit from '@/components/WeeklyRechargeBenefit'
import mall from '@/components/mall'
import mall_my from '@/components/mall_my'
import select_friends from '@/components/select_friends'
import feedback_order from '@/components/feedback_order'

import red_log from '@/components/red_log'
import red_order from '@/components/red_order'
import article from '@/components/article'
import wallet_withdraw from '@/components/wallet_withdraw'
import wallet_information from '@/components/wallet_information'

import exchange_coin from '@/components/exchange_coin'
import coin_dealer_exchange from '@/components/coin_dealer_exchange'
import coin_dealer_level from '@/components/coin_dealer_level'
import guard_list from '@/components/guard_list'
import select_share_friends from '@/components/select_share_friends'

Vue.use(Router)
export default new Router({
  base: '/h5/',
  mode: 'history',
  routes: [
    {
      path: '/shop',
      name: 'shop',
      component: shop,
      meta: {
        title: '道具商城'
      }
    },
    {
      path: '/noble',
      name: 'noble',
      component: noble,
      meta: {
        title: '贵族列表'
      }
    },
    {
      path: '/earnings',
      name: 'earnings',
      component: earnings,
      meta: {
        title: '收益记录'
      }
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: invitation,
      meta: {
        title: '邀请奖励 --作废'
      }
    },
    {
      path: '/invitationSubordinate',
      name: 'invitationSubordinate',
      component: invitationSubordinate,
      meta: {
        title: '我的团队'
      }
    },
    {
      path: '/invitationSuperior',
      name: 'invitationSuperior',
      component: invitationSuperior,
      meta: {
        title: '我的上级'
      }
    },
    {
      path: '/invitationEarnings',
      name: 'invitationEarnings',
      component: invitationEarnings,
      meta: {
        title: '团队收益详情'
      }
    },
    {
      path: '/invitationRecord',
      name: 'invitationRecord',
      component: invitationRecord,
      meta: {
        title: '分销提现记录'
      }
    },
    {
      path: '/invitationWithdrawal',
      name: 'invitationWithdrawal',
      component: invitationWithdrawal,
      meta: {
        title: '分销提现'
      }
    },
    {
      path: '/invitationPinless',
      name: 'invitationPinless',
      component: invitationPinless,
      meta: {
        title: '绑定账号'
      }
    },
    {
      path: '/invitationShare',
      name: 'invitationShare',
      component: invitationShare,
      meta: {
        title: '邀请分享页面'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact,
      meta: {
        title: '设置联系方式'
      }
    },
    {
      path: '/emcee_center',
      name: 'emcee_center',
      component: emcee_center,
      meta: {
        title: '主播中心'
      }
    },
    {
      path: '/emcee_income_log',
      name: 'emcee_income_log',
      component: emcee_income_log,
      meta: {
        title: '收入记录'
      }
    },
    {
      path: '/emcee_center_select_live_time',
      name: 'emcee_center_select_live_time',
      component: emcee_center_select_live_time,
      meta: {
        title: '直播时长查询'
      }
    },
    {
      path: '/my_shop',
      name: 'my_shop',
      component: my_shop,
      meta: {
        title: '我的小店'
      }
    },
    {
      path: '/create_shop',
      name: 'create_shop',
      component: create_shop,
      meta: {
        title: '创建店铺'
      }
    },
    {
      path: '/shop_manage',
      name: 'shop_manage',
      component: shop_manage,
      meta: {
        title: '店铺管理'
      }
    },
    {
      path: '/shop_add',
      name: 'shop_add',
      component: shop_add,
      meta: {
        title: '店铺管理'
      }
    },
    {
      path: '/shop_product_list',
      name: 'shop_product_list',
      component: shop_product_list,
      meta: {
        title: '商品管理'
      }
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta: {
        title: 'vip等级'
      }
    },
    {
      path: '/vip_grade',
      name: 'vip_grade',
      component: vip_grade,
      meta: {
        title: 'vip等级'
      }
    },
    {
      path: '/vip_task',
      name: 'vip_task',
      component: vip_task,
      meta: {
        title: 'vip任务升级'
      }
    },
    {
      path: '/agent',
      name: 'agent',
      component: agent,
      meta: {
        title: '分销等级'
      }
    },
		{
		  path: '/UpSharemoney',
		  name: 'UpSharemoney',
		  component: UpSharemoney,
		  meta: {
		    title: '更改分享赚钱'
		  }
		},
    {
		  path: '/shareDownload',
		  name: 'shareDownload',
		  component: shareDownload,
		  meta: {
		    title: '分享下载'
		  }
		},
    {
		  path: '/invitationRules',
		  name: 'invitationRules',
		  component: invitationRules,
		  meta: {
		    title: '邀请规则'
		  }
		},
    {
		  path: '/reflect',
		  name: 'reflect',
		  component: reflect,
		  meta: {
		    title: '提现'
		  }
		},
    {
		  path: '/firstlevelteam',
		  name: 'firstlevelteam',
		  component: firstlevelteam,
		  meta: {
		    title: '一级团队'
		  }
		},
    {
		  path: '/RealnameAuthentication',
		  name: 'RealnameAuthentication',
		  component: RealnameAuthentication,
		  meta: {
		    title: '实名认证'
		  }
		},
    {
      path: '/download',
      name: 'download',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/shareLive',
      name: 'shareLive',
      component: shareLive,
      meta: {
        title: '分享直播间'
      }
    },
    {
      path: '/turntable',
      name: 'turntable',
      component: turntable,
      meta: {
        title: '转盘'
      }
    },
    {
      path: '/banding_bank',
      name: 'banding_bank',
      component: banding_bank,
      meta: {
        title: '绑定银行卡'
      }
    },
    {
      path: '/greedy',
      name: 'greedy',
      component: greedy,
      meta: {
        title: '贪婪的鱼'
      }
    },
    {
      path: '/agent_login',
      name: 'agent_login',
      component: agent_login,
      meta: {
        title: '平台代理登录'
      }
    },
    {
      path: '/agent_admin',
      name: 'agent_admin',
      component: agent_admin,
      meta: {
        title: '平台代理'
      }
    },
    {
      path: '/video_rich_ranking',
      name: 'video_rich_ranking',
      component: video_rich_ranking,
      meta: {
        title: '富豪榜'
      }
    },
    {
      path: '/game_list',
      name: 'game_list',
      component: game_list,
      meta: {
        title: '游戏列表'
      }
    },
    {
      path: '/game_picture_list',
      name: 'game_picture_list',
      component: game_picture_list,
      meta: {
        title: '游戏列表-背景图'
      }
    },
    {
      path: '/month_statistics',
        name: 'month_statistics',
      component: month_statistics,
      meta: {
        title: '主播收益-月统计'
      }
    },
    {
      path: '/month_statistics_log',
        name: 'month_statistics_log',
      component: month_statistics_log,
      meta: {
        title: '主播收益-月统计记录'
      }
    },
    {
      path: '/avatar_frame',
      name: 'avatar_frame',
      component: avatar_frame,
      meta: {
        title: '头像框'
      }
    },
    {
      path: '/revenue_records',
      name: 'revenue_records',
      component: revenue_records,
      meta: {
        title: '主播收益记录'
      }
    },
    {
      path: '/play_svga',
      name: 'play_svga',
      component: play_svga,
      meta: {
        title: '播放svga'
      }
    },
    {
      path: '/room_flow',
      name: 'room_flow',
      component: room_flow,
      meta: {
        title: '房间流水'
      }
    },
    {
      path: '/item_shop',
      name: 'item_shop',
      component: item_shop,
      meta: {
        title: '道具商店'
      }
    },
    {
      path: '/item_shop_car',
      name: 'item_shop_car',
      component: item_shop_car,
      meta: {
        title: '道具商店:座驾'
      }
    },
    {
      path: '/item_shop_avatar',
      name: 'item_shop_avatar',
      component: item_shop_avatar,
      meta: {
        title: '道具商店:头像框'
      }
    },
    {
      path: '/item_shop_lucky',
      name: 'item_shop_lucky',
      component: item_shop_lucky,
      meta: {
        title: '道具商店:靓号'
      }
    },
    {
      path: '/item_shop_vip',
      name: 'item_shop_vip',
      component: item_shop_vip,
      meta: {
        title: '道具商店:VIP'
      }
    },
    {
      path: '/item_shop_my',
      name: 'item_shop_my',
      component: item_shop_my,
      meta: {
        title: '道具商店:我的道具'
      }
    },
    {
      path: '/banding_top_bank',
      name: 'banding_top_bank',
      component: banding_top_bank,
      meta: {
        title: '绑定top提现银行卡'
      }
    },
    {
      path: '/ranking_user',
      name: 'ranking_user',
      component: ranking_user,
      meta: {
        title: '排行榜'
      }
    },
    {
      path: '/agency_recharge',
      name: 'agency_recharge',
      component: agency_recharge,
      meta: {
        title: '代理充值'
      }
    },
    {
      path: '/ranking_family',
      name: 'ranking_family',
      component: ranking_family,
      meta: {
        title: '家族排行榜'
      }
    },
    {
      path: '/ranking_homepage',
      name: 'ranking_homepage',
      component: ranking_homepage,
      meta: {
        title: '主播主页排行榜'
      }
    },
    {
      path: '/creator_agency_apply',
      name: 'creator_agency_apply',
      component: creator_agency_apply,
      meta: {
        title: '申请创作代理'
      }
    },
    {
      path: '/creator_agency_apply_details',
      name: 'creator_agency_apply_details',
      component: creator_agency_apply_details,
      meta: {
        title: '申请创作代理文章说明'
      }
    },
    {
      path: '/creator_agency',
      name: 'creator_agency',
      component: creator_agency,
      meta: {
        title: '创作代理中心'
      }
    },
    {
      path: '/creator_success',
      name: 'creator_success',
      component: creator_success,
      meta: {
        title: '创作申请成功跳转页面'
      }
    },
    {
      path: '/my_agency',
      name: 'my_agency',
      component: my_agency,
      meta: {
        title: 'My Agency'
      }
    },
    {
      path: '/join_agency',
      name: 'join_agency',
      component: join_agency,
      meta: {
        title: '绑定公会页面'
      }
    },
    {
      path: '/creator_user',
      name: 'creator_user',
      component: creator_user,
      meta: {
        title: '创作中心'
      }
    },
    {
      path: '/creator_daily_income',
      name: 'creator_daily_income',
      component: creator_daily_income,
      meta: {
        title: '创作者每日详情'
      }
    },
    {
      path: '/creator_user_commission',
      name: 'creator_user_commission',
      component: creator_user_commission,
      meta: {
        title: '创作者收益提成展示'
      }
    },
    {
      path: '/approve_order',
      name: 'approve_order',
      component: approve_order,
      meta: {
        title: '批准工资单详情'
      }
    },
    {
      path: '/withdraw_payroll_order',
      name: 'withdraw_payroll_order',
      component: withdraw_payroll_order,
      meta: {
        title: '工资单详情'
      }
    },
    {
      path: '/withdraw_payroll_search_order',
      name: 'withdraw_payroll_search_order',
      component: withdraw_payroll_search_order,
      meta: {
        title: '搜索工资单'
      }
    },
    {
      path: '/withdraw_payroll',
      name: 'withdraw_payroll',
      component: withdraw_payroll,
      meta: {
        title: '工资单-结算专员'
      }
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
      meta: {
        title: '钱包'
      }
    },
    {
      path: '/wallet_details',
      name: 'wallet_details',
      component: wallet_details,
      meta: {
        title: '钱包明细'
      }
    },
    {
      path: '/withdraw_record',
      name: 'withdraw_record',
      component: withdraw_record,
      meta: {
        title: '提现记录'
      }
    },
    {
      path: '/coin_seller',
      name: 'coin_seller',
      component: coin_seller,
      meta: {
        title: '币商2025'
      }
    },
    {
      path: '/coin_seller_recharge',
      name: 'coin_seller_recharge',
      component: coin_seller_recharge,
      meta: {
        title: '币商充值'
      }
    },
    {
      path: '/coin_seller_payment_method_select',
      name: 'coin_seller_payment_method_select',
      component: coin_seller_payment_method_select,
      meta: {
        title: '币商支付方式选择'
      }
    },
    {
      path: '/coin_seller_payment_method',
      name: 'coin_seller_payment_method',
      component: coin_seller_payment_method,
      meta: {
        title: '币商支付方式'
      }
    },
    {
      path: '/coin_seller_details',
      name: 'coin_seller_details',
      component: coin_seller_details,
      meta: {
        title: '币商钻石明细'
      }
    },
    {
      path: '/coin_seller_details_v2',
      name: 'coin_seller_details_v2',
      component: coin_seller_details_v2,
      meta: {
        title: '币商钻石明细v2'
      }
    },
    {
      path: '/creator_agency_history',
      name: 'creator_agency_history',
      component: creator_agency_history,
      meta: {
        title: '创作代理历史记录'
      }
    },
    {
      path: '/coin_seller_ranking',
      name: 'coin_seller_ranking',
      component: coin_seller_ranking,
      meta: {
        title: '币商排行榜'
      }
    },
    {
      path: '/edit_quick_messages',
      name: 'edit_quick_messages',
      component: edit_quick_messages,
      meta: {
        title: '币商编辑快速消息'
      }
    },
    {
      path: '/payroll_seller_payment_method',
      name: 'payroll_seller_payment_method',
      component: payroll_seller_payment_method,
      meta: {
        title: '结算专员绑定的货币列表'
      }
    },
    {
      path: '/payroll_seller_payment_method_select',
      name: 'payroll_seller_payment_method_select',
      component: payroll_seller_payment_method_select,
      meta: {
        title: '结算专员绑定的支付方式'
      }
    },
    {
      path: '/help_feedback',
      name: 'help_feedback',
      component: help_feedback,
      meta: {
        title: '帮助反馈'
      }
    },
    {
      path: '/sign_in',
      name: 'sign_in',
      component: sign_in,
      meta: {
        title: '签到'
      }
    },
    {
      path: '/ranking_all',
      name: 'ranking_all',
      component: ranking_all,
      meta: {
        title: '收益排行榜(有奖励的)'
      }
    },
    {
      path: '/ranking_all_reward',
      name: 'ranking_all_reward',
      component: ranking_all_reward,
      meta: {
        title: '收益排行榜(有奖励的)'
      }
    },
    {
      path: '/withdraw_message',
      name: 'withdraw_message',
      component: withdraw_message,
      meta: {
        title: '提现消息'
      }
    },
    {
      path: '/withdraw_message_new',
      name: 'withdraw_message_new',
      component: withdraw_message_new,
      meta: {
        title: '提现状态通知'
      }
    },
    {
      path: '/my_level',
      name: 'my_level',
      component: my_level,
      meta: {
        title: '我的等级'
      }
    },
    {
      path: '/rank_coin',
      name: 'rank_coin',
      component: rank_coin,
      meta: {
        title: '主播下硬币贡献榜'
      }
    },
    {
      path: '/rank_list',
      name: 'rank_list',
      component: rank_list,
      meta: {
        title: '首页排行榜'
      }
    },
    {
      path: '/online_service',
      name: 'online_service',
      component: online_service,
      meta: {
        title: '在线服务-币商'
      }
    },
    {
      path: '/feedback_log',
      name: 'feedback_log',
      component: feedback_log,
      meta: {
        title: '我的反馈'
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback,
      meta: {
        title: '提交反馈'
      }
    },
    {
      path: '/follow_us',
      name: 'follow_us',
      component: follow_us,
      meta: {
        title: '关注我们'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: help,
      meta: {
        title: '帮助'
      }
    },
    {
      path: '/feedback_message',
      name: 'feedback_message',
      component: feedback_message,
      meta: {
        title: '反馈对话'
      }
    },
     {
      path: '/feedback_order',
      name: 'feedback_order',
      component: feedback_order,
      meta: {
        title: '订单反馈'
      }
    },
    {
      path: '/about_us',
      name: 'about_us',
      component: about_us,
      meta: {
        title: '关于我们'
      }
    },
        {
        path: '/vip_noble',
        name: 'vip_noble',
        component: vip_noble,
        meta: {
            title: 'vip贵族'
        }
    },
     {
        path: '/creator_country',
        name: 'creator_country',
        component: creator_country,
        meta: {
            title: '创作国家代理'
        }
    },
    {
        path: '/creator_country_invite',
        name: 'creator_country_invite',
        component: creator_country_invite,
        meta: {
            title: '创作国家代理邀请'
        }
    },
     {
        path: '/creator_country_reward_record',
        name: 'creator_country_reward_record',
        component: creator_country_reward_record,
        meta: {
            title: '创作国家代理奖励记录'
        }
    },
    {
        path: '/creator_country_agency',
        name: 'creator_country_agency',
        component: creator_country_agency,
        meta: {
            title: '创作国家代理列表'
        }
    },
    {
        path: '/creator_country_user',
        name: 'creator_country_user',
        component: creator_country_user,
        meta: {
            title: '创作国家创作者列表'
        }
    },
    {
        path: '/creator_country_agency_income',
        name: 'creator_country_agency_income',
        component: creator_country_agency_income,
        meta: {
            title: '创作国家代理收益列表'
        }
    },
    {
        path: '/creator_country_user_income',
        name: 'creator_country_user_income',
        component: creator_country_user_income,
        meta: {
            title: '创作国家创作者收益列表'
        }
    },
     {
        path: '/creator_country_invite_success',
        name: 'creator_country_invite_success',
        component: creator_country_invite_success,
        meta: {
            title: '创作国家代理邀请成功'
        }
    },
    {
        path: '/coin_dealer',
        name: 'coin_dealer',
        component: coin_dealer,
        meta: {
            title: '币商v1版本'
        }
    },
    {
        path: '/coin_dealer_v2',
        name: 'coin_dealer_v2',
        component: coin_dealer_v2,
        meta: {
            title: '币商v2版本'
        }
    },
     {
        path: '/coin_dealer_recharge_exchange',
        name: 'coin_dealer_recharge_exchange',
        component: coin_dealer_recharge_exchange,
        meta: {
            title: '币商2026.3-充值兑换v1'
        }
    },
      {
        path: '/coin_dealer_recharge_exchange_v2',
        name: 'coin_dealer_recharge_exchange_v2',
        component: coin_dealer_recharge_exchange_v2,
        meta: {
            title: '币商充值兑换v2'
        }
    },
         {
        path: '/coin_dealer_level',
        name: 'coin_dealer_level',
        component: coin_dealer_level,
        meta: {
            title: '币商2026.3-等级说明'
        }
    },
    {
        path: '/coin_dealer_rule',
        name: 'coin_dealer_rule',
        component: coin_dealer_rule,
        meta: {
            title: '币商2026.3-规则'
        }
    },
    {
        path: '/host_activity',
        name: 'host_activity',
        component: host_activity,
        meta: {
            title: '主播活动中心'
        }
    },
    {
        path: '/host_activity_rule',
        name: 'host_activity_rule',
        component: host_activity_rule,
        meta: {
            title: '主播活动规则'
        }
    },
     {
        path: '/host_activity_log',
        name: 'host_activity_log',
        component: host_activity_log,
        meta: {
            title: '主播活动领取记录'
        }
    },
     {
        path: '/bdm_system',
        name: 'bdm_system',
        component: bdm_system,
        meta: {
            title: 'BDM系统'
        }
    },
     {
        path: '/agc_system',
        name: 'agc_system',
        component: agc_system,
        meta: {
            title: 'AGC系统'
        }
    },
    {
        path: '/bdm_center',
        name: 'bdm_center',
        component: bdm_center,
        meta: {
            title: 'bdm 中心'
        }
    },
    {
        path: '/agc_center',
        name: 'agc_center',
        component: agc_center,
        meta: {
            title: 'agc 中心'
        }
    },
    {
        path: '/bdm_management',
        name: 'bdm_management',
        component: bdm_management,
        meta: {
            title: 'ADMIN、BD、AGC管理'
        }
    },
    {
        path: '/bdm_seller_management',
        name: 'bdm_seller_management',
        component: bdm_seller_management,
        meta: {
            title: 'BDM下币商管理'
        }
    },
     {
        path: '/bdm_payroll_management',
        name: 'bdm_payroll_management',
        component: bdm_payroll_management,
        meta: {
            title: 'BDM下结算专员管理'
        }
    },
    {
        path: '/bdm_host_management',
        name: 'bdm_host_management',
        component: bdm_host_management,
        meta: {
            title: 'BDM下主播管理'
        }
    },
    {
        path: '/bdm_distribute_reward',
        name: 'bdm_distribute_reward',
        component: bdm_distribute_reward,
        meta: {
            title: 'BDM下分配奖励'
        }
    },
    {
        path: '/bdm_distribute_reward_log',
        name: 'bdm_distribute_reward_log',
        component: bdm_distribute_reward_log,
        meta: {
            title: 'BDM下分配奖励记录'
        }
    },
    {
        path: '/bdm_reward_log',
        name: 'bdm_reward_log',
        component: bdm_reward_log,
        meta: {
            title: 'BDM奖励记录'
        }
    },
    {
        path: '/bdm_host_rank',
        name: 'bdm_host_rank',
        component: bdm_host_rank,
        meta: {
            title: 'BDM主播排名'
        }
    },
    {
        path: '/bdm_article',
        name: 'bdm_article',
        component: bdm_article,
        meta: {
            title: 'BDM文章'
        }
    },
    {
        path: '/bdm_message',
        name: 'bdm_message',
        component: bdm_message,
        meta: {
            title: 'BDM消息'
        }
    },
    {
        path: '/weekly_recharge_benefit',
        name: 'weekly_recharge_benefit',
        component: weekly_recharge_benefit,
        meta: { title: '每周充值福利' }
    },
    {
      path: '/mall',
      name: 'mall',
      component: mall,
      meta: { title: '商城' }
    },
    {
      path: '/mall_my',
      name: 'mall_my',
      component: mall_my,
      meta: { title: '我的商城' }
    },
    {
      path: '/select_friends',
      name: 'select_friends',
      component: select_friends,
      meta: { title: '选择赠送对象' }
    },
     {
      path: '/red_log',
      name: 'red_log',
      component: red_log,
      meta: {
        title: '红包记录'
      }
    },
    {
      path: '/red_order',
      name: 'red_order',
      component: red_order,
      meta: {
        title: '红包明细'
      }
    },
     {
      path: '/article',
      name: 'article',
      component: article,
      meta: {
        title: '公用文章'
      }
    },
    {
      path: '/wallet_information',
      name: 'wallet_information',
      component: wallet_information,
      meta: {
        title: '钱包'
      }
    },
     {
      path: '/wallet_withdraw',
      name: 'wallet_withdraw',
      component: wallet_withdraw,
      meta: {
        title: '钱包提现'
      }
    },
    {
      path: '/exchange_coin',
      name: 'exchange_coin',
      component: exchange_coin,
      meta: {
        title: '钱包收益兑换钻石'
      }
    }, 
    {
      path: '/coin_dealer_exchange',
      name: 'coin_dealer_exchange',
      component: coin_dealer_exchange,
      meta: {
        title: '币商兑换'
      }
    },
    {
      path: '/guard_list',
      name: 'guard_list',
      component: guard_list,
      meta: {
        title: '守护列表'
      }
    },
    {
      path: '/select_share_friends',
      name: 'select_share_friends',
      component: select_share_friends,
      meta: { title: '选择分享装扮商城对象' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js